import { LOGIN_URL_WITH_REDIRECT } from '../configs/auth'
import getSession from './getSession'

const setSessionOrRedirect = async (sessionSetter) => {
  const session = await getSession()

  if (sessionSetter) sessionSetter(session)

  if (!session) window.location.href = LOGIN_URL_WITH_REDIRECT

  return session
}

export default setSessionOrRedirect
